import {
  List,
  Datagrid,
  TextField,
  DateField,
  ImageField as RaImageField,
  ReferenceField,
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  Create,
  FileInput,
  FileField
} from "react-admin";
import MyRichTextInput from "./MyRichTextInput";

export const AnnouncementsList = () => (
  <List>
    <Datagrid>
      <TextField source="title" />
      <RaImageField source="image" />
      <ReferenceField label="Author" source="user_id" reference="users">
        <TextField source="username" />
      </ReferenceField>
      <DateField source="created_at" />
    </Datagrid>
  </List>
);

export const AnnouncementsEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="title" />
      <MyRichTextInput source="content" label="Content"  />
       <FileInput source="file" label="Upload PDF" accept="application/pdf">
        <FileField source="src" title="title" />
      </FileInput>
      <ImageInput source="image" accept="image/*">
        <RaImageField source="src" />
      </ImageInput>
    </SimpleForm>
  </Edit>
);

export const AnnouncementsCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="title" />
      <MyRichTextInput source="content" label="Content" />
      <FileInput source="file" label="Upload PDF" accept="application/pdf">
        <FileField source="src" title="title" />
      </FileInput>
      <ImageInput source="image" accept="image/*">
        <RaImageField source="src" />
      </ImageInput>
    </SimpleForm>
  </Create>
);
